import { Document, Page, Text, View } from '@react-pdf/renderer';
import { styles } from './style/pdfStyles';
import { PublicStructure } from './utils/pdfModel';
import { PdfCover } from './components/PdfCover';
import { PdfHeader } from './components/PdfHeader';
import { PdfFooter } from './components/PdfFooter';
import { PdfIndexSections } from './components/PdfIndexSections';
import { PdfIntro } from './components/PdfIntro';
import { PdfSummary } from './components/PdfSummary';
import { PdfModule } from './components/PdfModule';
import { findCompanyInfoModule, getFieldValue } from './utils/normalize';

interface PassportPdfProps {
  structure: PublicStructure;
}

export const PassportPdf = ({ structure }: PassportPdfProps) => {
  const modules = Array.isArray(structure.modules) ? structure.modules : [];
  const companyModule = findCompanyInfoModule(modules);
  const companyContent =
    (companyModule as { content?: Record<string, string> })?.content || {};

  // Best-effort fallback to a generic label when the profile is missing.
  const structureName =
    getFieldValue(companyContent, 'Nome struttura') || 'Struttura';
  const address = getFieldValue(companyContent, 'Indirizzo');

  return (
    <Document>
      <Page size="A4" style={styles.coverPage}>
        <PdfCover
          structureName={structureName}
          address={address}
          lastModified={structure.lastModified}
        />
      </Page>

      <Page size="A4" style={styles.page}>
        <PdfHeader structureName={structureName} />
        <PdfFooter idBackend={structure.id_backend} />
        <PdfIndexSections modules={modules} />
      </Page>

      <Page size="A4" style={styles.page}>
        <PdfHeader structureName={structureName} />
        <PdfFooter idBackend={structure.id_backend} />
        <PdfIntro publicInfos={structure.public_infos} modules={modules} />
      </Page>

      <Page size="A4" style={styles.page}>
        <PdfHeader structureName={structureName} />
        <PdfFooter idBackend={structure.id_backend} />
        <PdfSummary publicInfos={structure.public_infos} />
      </Page>

      {modules.map((module, index) => (
        <Page key={`${module.name}-${index}`} size="A4" style={styles.page}>
          <PdfHeader structureName={structureName} />
          <PdfFooter idBackend={structure.id_backend} />
          <PdfModule module={module} />
        </Page>
      ))}

      <Page size="A4" style={styles.page}>
        <PdfHeader structureName={structureName} />
        <PdfFooter idBackend={structure.id_backend} />
        <View>
          <Text style={styles.sectionTitle}>Note e contatti</Text>
          <Text style={styles.text}>
            Per note aggiuntive o contatti fare riferimento ai dati pubblici della
            struttura.
          </Text>
        </View>
      </Page>
    </Document>
  );
};
